import axios from 'axios';
import {getCustomerUrl} from '~/utils/customer-util';
import {StatusCodes} from "http-status-codes";

export default class SettingsService {
    static async loadSettings(cNum: string, serverBase: string) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/uisetting`);
        const resp = await axios.get(url);
        return resp.status === StatusCodes.OK ? resp.data : undefined;
    }
}
